import { initialStep } from '../config/step';

export const statePrefix = 'housingStock_imports_page';

export const stateKeys = {
  uploadingErrors: 'uploadingErrors',
  uploadingValues: 'uploadingValues',
  isFileUploading: 'isFileUploading',
  settingValues: 'settingValues',
  settingErrors: 'settingErrors',
  step: 'step',
  workbook: 'workbook',
  workbookSheetData: 'workbookSheetData',
  workbookValidationResult: 'workbookValidationResult',
  previewData: 'previewData',
  resultData: 'resultData',
};

export const actionTypes = {
  house_change: `${statePrefix}_house_change`,
  account_type_change: `${statePrefix}_account_type_change`,
  import_type_change: `${statePrefix}_import_type_change`,
  file_change: `${statePrefix}_file_change`,
  sheet_change: `${statePrefix}_sheet_change`,
  file_upload_started: `${statePrefix}_file_upload_started`,
  data_start_row_change: `${statePrefix}_data_start_row_change`,
  company_change: `${statePrefix}_company_change`,
  step_change: `${statePrefix}_step_change`,
  setting_field_change: `${statePrefix}_setting_field_change`,
  go_to_preview: `${statePrefix}_go_to_preview`,
  add_preview_data: `${statePrefix}_add_preview_data`,
  reset_state: `${statePrefix}_reset_state`,
  add_result_data: `${statePrefix}_add_result_data`,
};

export const getInitialState = () => ({
  [stateKeys.uploadingErrors]: new Map(),
  [stateKeys.uploadingValues]: new Map(),
  [stateKeys.settingValues]: new Map(),
  [stateKeys.settingErrors]: new Map(),
  [stateKeys.isFileUploading]: false,
  [stateKeys.step]: initialStep,
  [stateKeys.workbook]: undefined,
  [stateKeys.workbookSheetData]: undefined,
  [stateKeys.workbookValidationResult]: undefined,
  [stateKeys.previewData]: undefined,
  [stateKeys.resultData]: undefined,
});

export const getSettingStepRequiredFieldSize = (obj) => {
  if (!obj) return 0;
  const requiredFields = Object.values(obj).filter((value) => !value.optional);
  return requiredFields.length;
};
